import { render, staticRenderFns } from "./SandboxDetail.vue?vue&type=template&id=30439346&"
import script from "./SandboxDetail.vue?vue&type=script&lang=js&"
export * from "./SandboxDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports